import { Reveal } from "./motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const Manifesto = () => (
  <section id="stay-long" data-testid="manifesto" className="py-12 md:py-24 bg-[#F9F8F6]">
    <div className="max-w-[1400px] mx-auto px-5 md:px-10">
      <Reveal>
        <p className="font-body font-800 text-xs tracking-[0.3em] eyebrow text-[#DF3226] mb-4">
          HOW LONG TO STAY
        </p>
        <h2 className="font-display font-900 tracking-tighter leading-[0.9] text-4xl sm:text-5xl lg:text-6xl max-w-3xl">
          Give it <span className="font-editorial italic font-600">three days</span>.
          Two if you must, four if you can
        </h2>
        <p className="font-body text-base md:text-lg text-black/60 mt-6 max-w-xl leading-relaxed">
          Most people plan for three nights — and end up wishing they&apos;d booked four.
        </p>
        <Reveal>
          <Link
            to="/copenhagen-itinerary"
            data-testid="manifesto-itinerary-link"
            className="mt-8 inline-flex items-center gap-2 font-display font-800 bg-black text-white px-6 py-3 border border-black shadow-brut hover:-translate-y-0.5 hover:shadow-brut-lg transition-all"
          >
            See the ready-made 3-day itinerary
          </Link>
        </Reveal>
      </Reveal>
    </div>
  </section>
);
